export const UNIT_OPTIONS = [
  { value: 'tonne', label: 'Tonne (t)' },
  { value: 'kg', label: 'Kilogram (kg)' },
  { value: 'g', label: 'Gram (g)' },
  { value: 'litre', label: 'Litre (L)' },
  { value: 'bag', label: 'Bag' },
  { value: 'crate', label: 'Crate' },
  { value: 'pack', label: 'Pack' },
  { value: 'bunch', label: 'Bunch' },
  { value: 'piece', label: 'Piece' },
];

const MASS_IN_KG = { tonne: 1000, kg: 1, g: 0.001 };

export const formatSellingUnit = (unitValue = 1, unit = 'kg') => {
  const value = Number(unitValue) || 1;
  return `${value} ${unit}`;
};

export const formatUnitConversion = (unitValue = 1, unit = 'kg') => {
  const value = Number(unitValue) || 1;
  if (!MASS_IN_KG[unit]) return `${formatSellingUnit(value, unit)} per sale unit`;
  if (unit === 'tonne') return `${formatSellingUnit(value, unit)} = ${value * 1000} kg`;
  const kilograms = value * MASS_IN_KG[unit];
  if (kilograms >= 1000) return `${formatSellingUnit(value, unit)} = ${kilograms / 1000} tonne`;
  if (kilograms >= 1) return `${formatSellingUnit(value, unit)} = ${kilograms} kg`;
  return `${formatSellingUnit(value, unit)} = ${kilograms * 1000} g`;
};